<!-- pruebas-expediente.component.html -->
<mat-card appearance="outlined">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Pruebas</h2>
      <app-button-new mat-stroked-button color="primary" [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"></app-button-new>
      <mat-menu #menu="matMenu">
        <button mat-menu-item
          (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente}, modulo: 'pruebaPericial' })">
          <mat-icon>add</mat-icon>
          <span>Nueva Prueba Pericial</span>
        </button>
        <button mat-menu-item
          (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente}, modulo: 'pruebaConfesional' })">
          <mat-icon>add</mat-icon>
          <span>Nueva Prueba Confesional</span>
        </button>
        <button mat-menu-item
          (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente}, modulo: 'pruebaTestimonial' })">
          <mat-icon>add</mat-icon>
          <span>Nueva Prueba Testimonial</span>
        </button>
        <button mat-menu-item
          (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente}, modulo: 'pruebaInformativa' })">
          <mat-icon>add</mat-icon>
          <span>Nueva Prueba Informativa</span>
        </button>
      </mat-menu>
    </div>
  </mat-card-header>

  <mat-card-content>
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav #sidenav [mode]="'side'" [opened]="!isNavCollapsed" [fixedInViewport]="false" class="sidenav"
        [class.collapsed]="isNavCollapsed">

        <!-- Header con botón toggle -->
        <div class="sidenav-header">
          <button mat-icon-button class="toggle-btn" (click)="onMenuToggled(!isNavCollapsed)"
            [matTooltip]="isNavCollapsed ? 'Expandir' : 'Contraer'" matTooltipPosition="right">
            <mat-icon>{{ isNavCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
          </button>
        </div>

        <!-- Lista de navegación -->
        <div class="nav-items">
          <div *ngFor="let item of navItems" class="nav-item" [class.selected]="tipoSeleccionado === item.tipoPrueba"
            [matTooltip]="isNavCollapsed ? item.title : ''" matTooltipPosition="right"
            [matTooltipDisabled]="!isNavCollapsed" (click)="onCategoriaSeleccionada(item.tipoPrueba)">

            <div class="nav-item-content">
              <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>

              <div class="nav-text" *ngIf="!isNavCollapsed">
                <div class="nav-title">{{ item.title }}</div>
                <div class="nav-subtitle" [matTooltip]="item.subtitle" matTooltipPosition="below"
                  matTooltipClass="custom-tooltip">
                  {{ item.subtitle.length > 25 ? (item.subtitle | slice:0:20) + '...' : item.subtitle }}
                </div>

              </div>
            </div>
          </div>
        </div>
      </mat-sidenav>

      <mat-sidenav-content class="sidenav-content">
        <!-- Contenido principal -->
        <div *ngIf="pruebasExpediente === null" class="empty-state">
          <mat-icon class="empty-icon">folder_open</mat-icon>
          <h2>Sin pruebas seleccionadas</h2>
          <p>Selecciona un tipo de prueba del menú lateral para comenzar</p>
        </div>

        <div *ngIf="pruebasExpediente === tiposPruebasExpediente.PruebaPericial" class="content-section">
         <app-listado-pericia [idExpediente]="idExpediente" [showHeader]="false">
          </app-listado-pericia>
        </div>

        <div *ngIf="pruebasExpediente === tiposPruebasExpediente.PruebaInformativa" class="content-section">
          <app-listado-prueba-informativa [idExpediente]="idExpediente" [showHeader]="false">
          </app-listado-prueba-informativa>
        </div>

        <div *ngIf="pruebasExpediente === tiposPruebasExpediente.PruebaDocumentosLegales" class="content-section">
          <div class="coming-soon">
            <mat-icon class="feature-icon">description</mat-icon>
            <h2>Documentos Legales</h2>
            <p>Esta funcionalidad estará disponible próximamente</p>
          </div>
        </div>

        <div *ngIf="pruebasExpediente === tiposPruebasExpediente.PruebaTestimonios" class="content-section">
          <app-listado-prueba-testimonial [idExpediente]="idExpediente"
            [showHeader]="false"></app-listado-prueba-testimonial>
        </div>

        <div *ngIf="pruebasExpediente === tiposPruebasExpediente.PruebaConfesional" class="content-section">
           <app-listado-prueba-confesional [idExpediente]="idExpediente" [showHeader]="false">
          </app-listado-prueba-confesional>
        </div>

      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-card-content>
</mat-card>
